import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { confirmEmail } from '../services/api';

function ConfirmEmailPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) { setStatus('error'); setMessage('No confirmation token found.'); return; }

    confirmEmail(token)
      .then(() => setStatus('success'))
      .catch(err => {
        setStatus('error');
        setMessage(err.response?.data?.error || 'Confirmation failed.');
      });
  }, [searchParams]);

  return (
    <div className="a-auth-page">
      <div className="a-auth-card" style={{ textAlign: 'center' }}>
        <div className="a-auth-logo">
          <h1><span>SCALA</span> Performer</h1>
        </div>
        {status === 'loading' && <p style={{ color: '#6b7280' }}>Confirming your email…</p>}
        {status === 'success' && (
          <>
            <div className="a-success">Your email has been confirmed!</div>
            <p style={{ marginBottom: '1.5rem', color: '#374151', fontSize: '0.9rem' }}>
              You can now sign in and complete your performer profile.
            </p>
            <Link to="/login" className="a-btn a-btn--navy a-btn--full">Sign In</Link>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="a-error">{message}</div>
            <Link to="/register">Back to registration</Link>
          </>
        )}
      </div>
    </div>
  );
}

export default ConfirmEmailPage;
